import { api } from "../client";
import {
  EmailAccountFields,
  EmailAccountExtraFields,
} from "../schema/EmailAccount";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  EmailAccountFields & EmailAccountExtraFields,
  EmailAccountExtraFields
>;

export const getEmailAccounts = async (config?: ApiRequestConfig) => {
  return api.get<EmailAccountFields, EmailAccountExtraFields>(
    "email_accounts",
    config
  );
};

export const getEmailAccount = (id: number, config?: ApiRequestConfig) => {
  return api.get<EmailAccountFields, EmailAccountExtraFields>(
    `email_accounts/${id}`,
    config
  );
};
